<template>
	<div class="chat">
		<div class="ended-connection text-center" v-if="booking.status == 'CONFIRMED' && booking.timeslot.datetime < now">
			<p>Esperando que el médico comience la llamada<br /></p>
		</div>

		<div class="ended-connection text-center" v-if="booking.status == 'DONE' || booking.status == 'VIDEO_ENDED'">
			<p>La videoconsulta ha finalizado, Muchas gracias por su consulta.<br /></p>
		</div>

		<fullscreen ref="fullscreen" class="chat-box" v-if="showVideocall" @change="toggleFullscreen">
			<div class="box">
				<div class="medic-data">
					<h3>{{ booking.medic.fullname }}</h3>
					<h4>{{ elapsedTime }}</h4>
				</div>
				<div class="logo"></div>
				<button class="btn btn-outline-light btn-fullscreen" @click="$refs.fullscreen.toggle()">
					<i class="fa fa-expand" v-if="!fullscreen"></i>
					<i class="fa fa-compress" v-if="fullscreen"></i>
				</button>

				<div class="chat-container">
					<Session v-if="!loading" :sessionId="sessionId" :apiKey="apiKey" :token="token" :shareScreen="shareScreen" :muted="muted" />
				</div>

				<div class="button-bar">
					<button class="btn btn-outline-light" v-b-tooltip.hover placement="top" title="Compartir pantalla" @click="shareScreenToggle()">
						<i class="icon icon-share-screen-off" v-if="shareScreen"></i>
						<i class="icon icon-share-screen-on" v-if="!shareScreen"></i>
					</button>

					<button class="btn btn-outline-light" @click="muteToggle()" v-b-tooltip.hover placement="top" title="Silenciar">
						<i class="fa fa-microphone" v-if="!muted"></i>
						<i class="fa fa-microphone-slash" v-if="muted"></i>
					</button>
					<button class="btn btn-danger btn-hangout" v-b-tooltip.hover placement="top" title="Finalizar llamada" @click="videocallEnd()">
						<i class="fa fa-phone"></i>
					</button>
				</div>
			</div>
		</fullscreen>
	</div>
</template>

<script>
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'
import Session from '@/components/VideoVonage/Session'

export default {
	name: 'Chat',
	components: {
		Session,
	},
	props: ['booking'],
	data() {
		return {
			loading: true,
			sessionId: null,
			apiKey: null,
			token: null,
			showVideocall: false,
			shareScreen: false,
			muted: false,
			now: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
			isDebugging: false,
			fullscreen: false,
		}
	},
	computed: {
		elapsedTime: function() {
			if (this.booking.timeslot.datetime) {
				var a = this.$moment(this.now)
				var b = this.$moment(this.booking.timeslot.datetime)
				var diff = a.diff(b)
				return this.$moment.utc(diff).format('mm:ss')
			}
			return null
		},
	},

	async mounted() {
		console.log('chatVonage Componente Mounted')

		this.isDebugging = this.$route.query.debug

		setInterval(() => {
			this.now = this.$moment(this.now)
				.add(1, 'second')
				.format('YYYY-MM-DD HH:mm:ss')
		}, 1000)

		if (this.booking && this.booking.status == 'VIDEO_LIVE') {
			await this.getVideoToken()
			this.showVideocall = true
		}

		this.loading = false
	},

	beforeDestroy() {},

	methods: {
		shareScreenToggle() {
			this.shareScreen = !this.shareScreen
		},
		muteToggle() {
			this.muted = !this.muted
		},
		toggleFullscreen() {
			this.localVideo.fullscreen = !this.localVideo.fullscreen
		},
		async getVideoToken() {
			console.log('getVideoToken', this.booking)
			return axios
				.get(`/vonageVideoCreateToken?bookingId=${this.booking.id}`)
				.then(({ data }) => {
					console.log(data)
					this.sessionId = data.sessionId
					this.apiKey = data.apiKey
					this.token = data.token
					this.loading = false
					// this.createSession(data.apiKey, data.sessionId)
				})
				.catch((err) => {
					console.log(err)
				})
		},

		videocallEnd() {
			this.showVideocall = false
		},
	},
}
</script>

<style scoped>
.chat {
	width: 100%;
}
.ended-connection {
	width: 100%;
	padding-top: calc(10% - 18px);
	padding-bottom: calc(10% - 18px);
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f3f3f3;
}

.chat-box {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background-color: #252f39 !important;
	overflow: hidden !important;
	z-index: 1000;
	display: flex;
	justify-content: center;
	align-items: center;
}

.chat-box .box {
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.chat-box .box .medic-data {
	z-index: 1200;
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	padding: 18px;
	color: #fff;
	background: rgba(0, 0, 0, 0.5);
	background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: -webkit-gradient(
		left top,
		left bottom,
		color-stop(0%, rgba(0, 0, 0, 0.5)),
		color-stop(64%, rgba(0, 0, 0, 0)),
		color-stop(100%, rgba(0, 0, 0, 0))
	);
	background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: -o-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=0 );
}
.chat-box .box .medic-data h3 {
	font-size: 1rem;
	font-weight: 400;
	margin-bottom: 4px;
}
.chat-box .box .medic-data h4 {
	font-size: 0.8rem;
	font-weight: 400;
}

.logo {
	background: url(../assets/img/logo.png);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	width: 265px;
	height: 40px;
	position: absolute;
	top: 18px;
	right: 84px;
}

.button-bar {
	padding: 12px 8px;
	background-color: #333;
	border-radius: 38px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	bottom: 25px;
	z-index: 1300;
	left: auto;
}
@media (max-width: 767px) {
	.button-bar {
		left: 25px;
	}
}
.button-bar .btn {
	flex-grow: 0;
	flex-shrink: 0;
}
.button-bar .btn-hangout i {
	transform: rotate(134deg);
}
.button-bar .icon {
	width: 30px;
	height: 34px;
	display: block;
	background-size: contain;
	opacity: 0.9;
	filter: invert(1);
}
.button-bar .btn:hover .icon {
	filter: invert(0);
}

.chat-container /deep/ .OT_publisher {
	position: absolute;
	display: block;
	z-index: 1000;
	bottom: 24px;
	right: 24px;
	width: 240px !important;
	height: 180px !important;
}
.chat-container /deep/ .OT_subscriber {
	position: absolute;
	bottom: 0px;
	z-index: 500;
	right: 0px;
	left: 0px;
	top: 0px;
}

.btn-fullscreen {
	position: absolute;
	top: 14px;
	right: 14px;
	z-index: 1200;
}

.chat-box .btns {
	width: calc(70% - 28px);
	flex-grow: 1;
	display: flex;
	z-index: 10;
	align-items: center;
	justify-content: center;
}
.chat-box .btn {
	border-radius: 50%;
	width: 48px;
	height: 48px;
	font-size: 1.4rem;
	border: none;
	opacity: 0.7;
	margin: 0px 8px;
	padding: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.chat-box .btn:hover {
	opacity: 1;
}
</style>
